import { render, staticRenderFns } from "./CompanyDeleteProvider.vue?vue&type=template&id=3654ce7e&scoped=true&"
import script from "./CompanyDeleteProvider.vue?vue&type=script&lang=ts&"
export * from "./CompanyDeleteProvider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3654ce7e",
  null
  
)

export default component.exports